import * as React from "react";
// import { classes } from "@eave/core-ui";
import classnames from "classnames";

const styles = require("./Address.module.scss");

interface Address {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
}

interface Props {
  format?: "inline" | "multi";
  className?: string;
  address: Address;
  phone?: { number: string; display: string };
}

export const Address = ({ format = "inline", className, address, phone }: Props) => {
  const { line1, line2, city, state, zip } = address;
  let addressHTML;

  if (format === "multi") {
    addressHTML = (
      <>
        <div>{line1}</div>
        {line2 && <div>{line2}</div>}
        <div>{`${city}, ${state} ${zip}`}</div>
        {phone && <a href={`tel:${phone.number}`}>{phone.display}</a>}
      </>
    );
  } else {
    addressHTML = `${line1}, ${line2 ? `${line2}, ` : ""}${city}, ${state} ${zip}${
      phone ? `, ${phone.display}` : ""
    }`;
  }

  return (
    <address className={classnames(styles[format], className, styles.addressComponent)}>
      {addressHTML}
    </address>
  );
};

export default Address;
